/**
 *
 * Created Date: 2019-04-01, 11:04:53 (zhenliang.sun)
 * Last Modified: 2019-08-14, 15:05:33 (zhenliang.sun)
 * Email: zhenliang.sun@gmail.com
 *
 * Distributed under the MIT license. See LICENSE file for details.
 * Copyright (c) 2019 vhall
 */
import { fabric } from 'fabric';
import { GraphName, GraphType } from './../constants/Constants';
import CanvasArrowBase from './CanvasArrowBase';
/**
 * 单向箭头
 *
 * @export
 * @class CanvasSingleArrow
 * @extends {CanvasArrowBase}
 * @author zhenliang.sun
 */
export default class CanvasSingleArrow extends CanvasArrowBase {
  constructor(app) {
    super(app);
  }

  static toAddData(target) {
    let obj = CanvasArrowBase.toAddData(target);
    obj.gtype = GraphType.SINGLE_ARROW;
    obj.path = target.path;
    return obj;
  }

  _mouseMoveHandler(o) {
    super._mouseMoveHandler(o);
    if (!this._isMouseDown) {
      return;
    }

    if (this._shape) {
      this.root.remove(this._shape);
    }

    let tp = this.root.getPointer(o.e);
    let targetX = tp.x;
    let targetY = tp.y;

    const offsetX = Math.abs(this.ox - targetX);
    const offsetY = Math.abs(this.oy - targetY);
    if (Math.sqrt(offsetX ** 2 + offsetY ** 2) < 10) {
      this._shouldSend = false;
      return;
    }

    this._shouldSend = true;
    this._shape = new fabric[GraphName.SINGLE_ARROW](this.drawArrow(this.ox, this.oy, targetX, targetY, 45, 20), {
      stroke: this._option.stroke,
      strokeWidth: this._option.strokeWidth,
      fill: '',
      objectCaching: false,
      selectable: false,
      strokeLineCap: 'round',
      strokeLineJoin: 'round',
      strokeMiterLimit: 1
    });

    this.root.add(this._shape);
    this.stage.renderNow();
  }

  /**
   * 画三角
   *
   * @param {*} fromX 起始点横坐标
   * @param {*} fromY 起始点纵坐标
   * @param {*} toX 目标点横坐标
   * @param {*} toY 目标点纵坐标
   * @param {*} theta 角度
   * @param {*} headlen 边线长度
   * @returns 返回这个箭头的path
   * @memberof CanvasSingleArrow
   */
  drawArrow(fromX, fromY, toX, toY, theta, headlen) {
    theta = typeof theta !== 'undefined' ? theta : 30;
    headlen = typeof theta !== 'undefined' ? headlen : 10;
    // 计算各角度和对应的P2,P3坐标
    var angle = (Math.atan2(fromY - toY, fromX - toX) * 180) / Math.PI;
    var angle1 = ((angle + theta) * Math.PI) / 180;
    var angle2 = ((angle - theta) * Math.PI) / 180;
    var topX = this._toFixed(headlen * Math.cos(angle1));
    var topY = this._toFixed(headlen * Math.sin(angle1));
    var botX = this._toFixed(headlen * Math.cos(angle2));
    var botY = this._toFixed(headlen * Math.sin(angle2));
    fromX = this._toFixed(fromX);
    fromY = this._toFixed(fromY);
    toX = this._toFixed(toX);
    toY = this._toFixed(toY);

    var arrowX = this._toFixed(fromX - topX);
    var arrowY = this._toFixed(fromY - topY);

    var path = ' M ' + fromX + ' ' + fromY;
    path += ' L ' + toX + ' ' + toY;
    arrowX = this._toFixed(toX + topX);
    arrowY = this._toFixed(toY + topY);
    path += ' M ' + arrowX + ' ' + arrowY;
    path += ' L ' + toX + ' ' + toY;
    arrowX = this._toFixed(toX + botX);
    arrowY = this._toFixed(toY + botY);
    path += ' L ' + arrowX + ' ' + arrowY;
    return path;
  }

  _toFixed(num, precision = 1) {
    return +num.toFixed(precision);
  }
}
